<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Outcome</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="outcomes.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="outcomes.description"
                v-validate="'required'"
                data-vv-as="Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Action Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="outcomes.action_type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('action_type')"
              >{{ errors.first("action_type") }}</span
            >
          </div>

                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grade:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox class="mb-2" name="option" v-model="outcomes.grade" :vs-value="'2'" >{{ 'Attempted to call' }}</vs-checkbox>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Option:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
            <div v-for="(option, index) in options" :key="index">
        <vs-checkbox class="mb-2" name="option" v-model="outcomes.option" :vs-value="option" >{{ option.name }}</vs-checkbox>
</div>
              <!-- <v-select
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="outcomes.action_type"
                v-validate="'required'"
              /> -->
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('option')"
              >{{ errors.first("option") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'ActionTypeOutcomeOption'" 
            ref="outcomes"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleActionTypeManagement from "@/store/action-type-management/moduleActionTypeManagement.js";
import moduleOutcomeManagement from "@/store/outcome-management/moduleOutcomeManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      options : [
        {
          slug: "next",
          name: "Next"
        }
      ],
      action_types: [
      ],
      companySearchComponentKey: 0,
      columnDefs: [
        {
          headerName: "Name",
          flex: 1,
          field: "name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,
 
          headerName: "Description",
          field: "description",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
        headerName: "Action Type",
        field: "action_type",
        flex:1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Option",
        field: "action_type_outcome_option",
                flex:1,

        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Grade",
        field: "grade",
        flex:1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      ],
      dataSource: {},
      records: [],
      selected: [],
      allOutcomes: [],
      abilities: null,
      existing_list_values: [],
      existing_outcomes_list: [],
      outcomes: {
        name: null,
        description: null,
        action_type: null,
        option:[],
        grade:null,
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleOutcomeManagement,
    DataGrid
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOutcomeManagement.isRegistered) {
      this.$store.registerModule("OutcomesManagement", moduleOutcomeManagement);
      moduleOutcomeManagement.isRegistered = true;
    }

      if (!moduleActionTypeManagement.isRegistered) {
      this.$store.registerModule(
        "ActionTypesManagement",
        moduleActionTypeManagement
      );
      moduleActionTypeManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllActionTypes()
  },
  watch: {
    'outcomes.grade'(val){
      if(val == '2'){
        this.options = [
        {
          slug: "submit",
          name: "Submit"
        },
        {
          slug: "schedule_a_next_action",
          name: "Schedule a Next Action"
        },
        {
          slug: "no_i_dont_to_schedule_a_next_action",
          name: "No, I don't want to schedule a next action"
        }
      ]
      }else{
        this.options = [
        {
          slug: "next",
          name: "Next"
        }
      ]
      }
    }
  },
  methods: {
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("OutcomesManagement/getAllOutcomes", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.outcomes.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.outcomes.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addOutcomes();
        }
      });
    },
    fetchAllActionTypes() {
      var self = this;
      self.$store
            .dispatch(
              "OutcomesManagement/getAllActionTypesForOutcomes"
            )
            .then(function(response) {
              let response_data = response.data;
              self.action_types = response_data    
            })
            .catch(err => {
              console.log(err);
            });
    },
    addOutcomes() {
      
      this.outcomes.call_action_type_id = this.outcomes.action_type.id


      let outcome_option = [] 
      this.outcomes.option.map(function(ele){
          outcome_option.push(ele.slug)
      })
      this.outcomes.option = outcome_option
      this.$store
        .dispatch("OutcomesManagement/addOutcomes", this.outcomes)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Outcomes Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Outcomes Added",
              text: "The outcomes was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/outcomes" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
